export default __webpack_public_path__ + "static/media/indiana3.4c753d0a.svg";